export default {
  "ext": "مفتاح.",
  "country": "الدولة",
  "phone": "رقم الهاتف",
  "AB": "أبخازيا",
  "AC": "جزيرة أسنسيون",
  "AD": "أندورا",
  "AE": "الإمارات العربية المتحدة",
  "AF": "أفغانستان",
  "AG": "أنتيغوا وباربودا",
  "AI": "أنغيلا",
  "AL": "ألبانيا",
  "AM": "أرمينيا",
  "AO": "أنغولا",
  "AQ": "القارة القطبية الجنوبية",
  "AR": "الأرجنتين",
  "AS": "ساموا الأمريكية",
  "AT": "النمسا",
  "AU": "أستراليا",
  "AW": "أروبا",
  "AX": "جزر آلاند",
  "AZ": "أذربيجان",
  "BA": "البوسنة والهرسك",
  "BB": "باربادوس",
  "BD": "بنغلاديش",
  "BE": "بلجيكا",
  "BF": "بوركينا فاسو",
  "BG": "بلغاريا",
  "BH": "البحرين",
  "BI": "بوروندي",
  "BJ": "بنين",
  "BL": "سانت بارتيليمي",
  "BM": "برمودا",
  "BN": "بروناي",
  "BO": "بوليفيا",
  "BQ": "بونير وسانت يوستاتيوس وسابا",
  "BR": "البرازيل",
  "BS": "باهاماس",
  "BT": "بوتان",
  "BV": "جزيرة بوفيت",
  "BW": "بوتسوانا",
  "BY": "بيلاروس",
  "BZ": "بليز",
  "CA": "كندا",
  "CC": "جزر كوكوس (كيلينغ)",
  "CD": "جمهورية الكونغو الديمقراطية",
  "CF": "جمهورية أفريقيا الوسطى",
  "CG": "جمهورية الكونغو",
  "CH": "سويسرا",
  "CI": "ساحل العاج",
  "CK": "جزر كوك",
  "CL": "تشيلي",
  "CM": "الكاميرون",
  "CN": "الصين",
  "CO": "كولومبيا",
  "CR": "كوستاريكا",
  "CU": "كوبا",
  "CV": "الرأس الأخضر",
  "CW": "كوراساو",
  "CX": "جزيرة الكريسماس",
  "CY": "قبرص",
  "CZ": "جمهورية التشيك",
  "DE": "ألمانيا",
  "DJ": "جيبوتي",
  "DK": "الدنمارك",
  "DM": "دومينيكا",
  "DO": "جمهورية الدومينيكان",
  "DZ": "الجزائر",
  "EC": "الإكوادور",
  "EE": "إستونيا",
  "EG": "مصر",
  "EH": "الصحراء الغربية",
  "ER": "إريتريا",
  "ES": "إسبانيا",
  "ET": "إثيوبيا",
  "FI": "فنلندا",
  "FJ": "فيجي",
  "FK": "جزر فوكلاند",
  "FM": "ولايات ميكرونيسيا المتحدة",
  "FO": "جزر فاروس",
  "FR": "فرنسا",
  "GA": "الغابون",
  "GB": "المملكة المتحدة",
  "GD": "غرينادا",
  "GE": "جورجيا",
  "GF": "غيانا الفرنسية",
  "GG": "غيرنسي",
  "GH": "غانا",
  "GI": "جبل طارق",
  "GL": "الأرض الخضراء",
  "GM": "غامبيا",
  "GN": "غينيا",
  "GP": "جوادلوب",
  "GQ": "غينيا الاستوائية",
  "GR": "اليونان",
  "GS": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  "GT": "غواتيمالا",
  "GU": "غوام",
  "GW": "غينيا بيساو",
  "GY": "غيانا",
  "HK": "هونج كونج",
  "HM": "قلب الجزيرة وجزر ماكدونالز",
  "HN": "هندوراس",
  "HR": "كرواتيا",
  "HT": "هايتي",
  "HU": "المجر",
  "ID": "إندونيسيا",
  "IE": "أيرلندا",
  "IL": "إسرائيل",
  "IM": "جزيرة آيل أوف مان",
  "IN": "الهند",
  "IO": "إقليم المحيط البريطاني الهندي",
  "IQ": "العراق",
  "IR": "إيران",
  "IS": "آيسلندا",
  "IT": "إيطاليا",
  "JE": "جيرسي",
  "JM": "جامايكا",
  "JO": "الأردن",
  "JP": "اليابان",
  "KE": "كينيا",
  "KG": "قيرغيزستان",
  "KH": "كمبوديا",
  "KI": "كيريباتي",
  "KM": "جزر القمر",
  "KN": "سانت كيتس ونيفيس",
  "KP": "كوريا الشمالية",
  "KR": "كوريا الجنوبية",
  "KW": "الكويت",
  "KY": "جزر كايمان",
  "KZ": "كازاخستان",
  "LA": "لاوس",
  "LB": "لبنان",
  "LC": "سانت لوسيا",
  "LI": "ليختنشتاين",
  "LK": "سريلانكا",
  "LR": "ليبيريا",
  "LS": "ليسوتو",
  "LT": "ليتوانيا",
  "LU": "لوكسمبورغ",
  "LV": "لاتفيا",
  "LY": "ليبيا",
  "MA": "المغرب",
  "MC": "موناكو",
  "MD": "مولدوفا",
  "ME": "الجبل الأسود",
  "MF": "سانت مارتن (الجزء الفرنسي)",
  "MG": "مدغشقر",
  "MH": "جزر مارشال",
  "MK": "مقدونيا",
  "ML": "مالي",
  "MM": "ميانمار",
  "MN": "منغوليا",
  "MO": "ماكاو",
  "MP": "جزر مريانا الشمالية",
  "MQ": "مارتينيك",
  "MR": "موريتانيا",
  "MS": "مونتسيرات",
  "MT": "مالطا",
  "MU": "موريشيوس",
  "MV": "جزر المالديف",
  "MW": "مالاوي",
  "MX": "المكسيك",
  "MY": "ماليزيا",
  "MZ": "موزمبيق",
  "NA": "ناميبيا",
  "NC": "كاليدونيا الجديدة",
  "NE": "النيجر",
  "NF": "جزيرة نورفولك",
  "NG": "نيجيريا",
  "NI": "نيكاراغوا",
  "NL": "هولندا",
  "NO": "النرويج",
  "NP": "نيبال",
  "NR": "ناورو",
  "NU": "نيوي",
  "NZ": "نيوزيلندا",
  "OM": "عمان",
  "OS": "أوسيتيا الجنوبية",
  "PA": "بنما",
  "PE": "بيرو",
  "PF": "بولينيزيا الفرنسية",
  "PG": "بابوا غينيا الجديدة",
  "PH": "الفلبين",
  "PK": "باكستان",
  "PL": "بولندا",
  "PM": "سانت بيير وميكلون",
  "PN": "بيتكيرن",
  "PR": "بورتوريكو",
  "PS": "فلسطين",
  "PT": "البرتغال",
  "PW": "بالاو",
  "PY": "باراغواي",
  "QA": "قطر",
  "RE": "جمع شمل",
  "RO": "رومانيا",
  "RS": "صربيا",
  "RU": "روسيا",
  "RW": "رواندا",
  "SA": "السعودية",
  "SB": "جزر سليمان",
  "SC": "سيشل",
  "SD": "السودان",
  "SE": "السويد",
  "SG": "سنغافورة",
  "SH": "سانت هيلانة",
  "SI": "سلوفينيا",
  "SJ": "سفالبارد وجان ماين",
  "SK": "سلوفاكيا",
  "SL": "سيراليون",
  "SM": "سان مارينو",
  "SN": "السنغال",
  "SO": "الصومال",
  "SR": "سورينام",
  "SS": "جنوب السودان",
  "ST": "ساو تومي وبرينسيب",
  "SV": "السلفادور",
  "SX": "سينت مارتن",
  "SY": "سوريا",
  "SZ": "إسواتيني",
  "TA": "تريستان دا كونها",
  "TC": "جزر تركس وكايكوس",
  "TD": "تشاد",
  "TF": "المناطق الجنوبية لفرنسا",
  "TG": "توغو",
  "TH": "تايلاند",
  "TJ": "طاجيكستان",
  "TK": "توكيلاو",
  "TL": "تيمور الشرقية",
  "TM": "تركمانستان",
  "TN": "تونس",
  "TO": "تونغا",
  "TR": "تركيا",
  "TT": "ترينيداد وتوباغو",
  "TV": "توفالو",
  "TW": "تايوان",
  "TZ": "تنزانيا",
  "UA": "أوكرانيا",
  "UG": "أوغندا",
  "UM": "جزر الولايات المتحدة البعيدة الصغرى",
  "US": "الولايات المتحدة",
  "UY": "الأوروغواي",
  "UZ": "أوزبكستان",
  "VA": "الكرسي الرسولي (دولة الفاتيكان)",
  "VC": "سانت فينسنت والغرينادين",
  "VE": "فنزويلا",
  "VG": "جزر العذراء البريطانية",
  "VI": "جزر فيرجن الأمريكية",
  "VN": "فيتنام",
  "VU": "فانواتو",
  "WF": "واليس وفوتونا",
  "WS": "ساموا",
  "XK": "كوسوفو",
  "YE": "اليمن",
  "YT": "مايوت",
  "ZA": "جنوب أفريقيا",
  "ZM": "زامبيا",
  "ZW": "زيمبابوي",
  "ZZ": "دولي"
}